import { UserResponseDto } from "utils/swagger_react_query";

export const getAddress = (user?: Partial<UserResponseDto> | null) => {
  //return user ? `${user.firstName} ${user.lastName}` : '';
  return `${user?.address}, ${user?.city} ${user?.state} ${user?.zip}`;
};
